import appCaptainAppVersion from "../../views/appSettings/captainAppVersionView.html";
import constants from "../../core/constants";

function urlsConfig($stateProvider) {
  "ngInject";

  $stateProvider.state("captainappversion", {
    url: "captain-app-version/:id",
    parent: "app",
    views: {
      view: {
        template: appCaptainAppVersion,
      },
    },
    reloadOnSearch: false,
    data: { title: "CaptainAppVersion" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/captainAppVersion/captainAppVersion.urls.js